/*
 * BOUSS — loader léger (marque = logo de la boutique, déjà mis en cache).
 * 1) Splash au 1er chargement de session (fondu à window.load).
 * 2) Placeholder « verre + logo » derrière les images produit/media tant
 *    qu'elles chargent ; repli sur la marque si une image échoue.
 * 3) Logo 3D du header « parqué » : image fixe dessinée une fois (pas 60/s).
 * 4) 3D en pause sous un panneau ouvert (tiroir, recherche, menu).
 * 5) Dock du hero figé tant qu'un panneau fige la page (header conservé).
 * 6) Galerie de la fiche conservée au changement de taille (mêmes photos).
 * Aucune dépendance. Se contente d'ajouter/retirer des classes (CSS dans
 * bouss.css). Dégradation propre : sans ce script, images et page normales.
 */
(function () {
  'use strict';

  /* ---- Splash ---------------------------------------------------------- */
  try { sessionStorage.setItem('bouss_splash_seen', '1'); } catch (e) {}
  var splash = document.querySelector('[data-bouss-splash]');
  if (splash) {
    var hidden = false;
    var hide = function () {
      if (hidden) return;
      hidden = true;
      splash.classList.add('is-hidden');
      setTimeout(function () { if (splash && splash.parentNode) splash.parentNode.removeChild(splash); }, 500);
    };
    if (document.readyState === 'complete') hide();
    else window.addEventListener('load', hide, { once: true });
    // Filet de sécurité si 'load' tarde : fondu lancé au plus tard 0,75 s après
    // le DÉBUT de la navigation (performance.now, pas l'exécution de ce script
    // en defer) → splash disparu en 1 s maximum. Doublé côté CSS
    // (snippets/bouss-loader.liquid) si ce script arrive en retard.
    var SPLASH_MAX_MS = 750;
    var elapsed = (window.performance && performance.now) ? performance.now() : 0;
    setTimeout(hide, Math.max(0, SPLASH_MAX_MS - elapsed));
  }

  /* ---- Placeholder d'images ------------------------------------------- */
  var SELECTOR = [
    '.card-gallery img',
    '.product-media-container img',
    '.product-media img',
    '.resource-card__media img',
    '.bouss-related img',
    '.bouss-drawer-slide__img'
  ].join(',');

  function mark(img) {
    if (img.dataset.boussLazy) return;
    img.dataset.boussLazy = '1';
    // Déjà chargée (cache) : rien à faire.
    if (img.complete && img.naturalWidth > 0) return;
    img.classList.add('bouss-lazy');
    img.addEventListener('load', function () {
      img.classList.add('is-loaded');
    }, { once: true });
    img.addEventListener('error', function () {
      // L'image a échoué : on garde la marque logo comme repli, sans shimmer.
      img.classList.add('is-broken');
    }, { once: true });
  }

  function scan() {
    var imgs = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < imgs.length; i++) mark(imgs[i]);
  }

  scan();

  // Contenus injectés (sections re-rendues, quick-add, pagination…) : re-scan
  // débounce pour ne pas peser.
  var t = null;
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) {
        if (t) clearTimeout(t);
        t = setTimeout(scan, 200);
        return;
      }
    }
  });
  try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}

  /* ---- Logo 3D du header « parqué » ------------------------------------ */
  // Sur la home, tant que le hero n'a pas docké son logo, <bouss-logo-header>
  // est « parqué » : rotation figée à 0, image strictement fixe. Le bundle
  // (bouss-logo-3d.js) la redessinait pourtant à chaque frame (60 rendus
  // WebGL/s pour une image immobile). On la dessine une fois, puis au plus
  // une fois par seconde (filet : texture tardive, contexte restauré), et on
  // relance la boucle dès que l'état change (dock, redimensionnement).
  // Surcouche sur le prototype : le bundle n'est pas modifié ; rendu identique.
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('bouss-logo-header').then(function () {
      var C = customElements.get('bouss-logo-header');
      var P = C && C.prototype;
      if (!P || P.__boussParkTuned || typeof P.tick !== 'function' || typeof P.layout !== 'function') return;
      P.__boussParkTuned = true;
      var tick = P.tick;
      var layout = P.layout;
      var PARK_REFRESH_MS = 1000;
      var body = document.body;

      function parked(el) {
        return !el.dataset.noPark &&
          body.classList.contains('bouss-has-hero') &&
          !body.classList.contains('bouss-docked');
      }
      function wake(el) {
        clearTimeout(el.__boussParkTimer);
        el.__boussParkTimer = 0;
        el.__boussParkDrawn = 0;
        if (el.isConnected && typeof el.schedule === 'function') el.schedule();
      }

      P.tick = function () {
        if (parked(this) && this.__boussParkDrawn) {
          var wait = PARK_REFRESH_MS - (performance.now() - this.__boussParkDrawn);
          if (wait > 0) {
            var self = this;
            this.raf = null;
            clearTimeout(this.__boussParkTimer);
            this.__boussParkTimer = setTimeout(function () { wake(self); }, wait);
            return;
          }
        }
        this.__boussParkDrawn = parked(this) ? performance.now() : 0;
        return tick.apply(this, arguments);
      };

      // setSize() efface le canvas : on force un nouveau rendu après layout.
      P.layout = function () {
        var r = layout.apply(this, arguments);
        if (this.__boussParkDrawn) wake(this);
        return r;
      };

      // Dock / dé-dock (classes posées sur <body> par le hero) → reprise.
      try {
        new MutationObserver(function () {
          var els = document.querySelectorAll('bouss-logo-header');
          for (var i = 0; i < els.length; i++) {
            if (els[i].__boussParkTimer && !parked(els[i])) wake(els[i]);
          }
        }).observe(body, { attributes: true, attributeFilter: ['class'] });
      } catch (e) {}
    });
  }

  /* ---- Pause de la 3D sous un panneau ouvert --------------------------- */
  // Tiroir panier, recherche (dialog modale) ou menu mobile ouverts : la 3D
  // (hero, logos, barbelés) est recouverte mais continuait de tourner à chaque
  // frame → animations du panneau saccadées et clics lents (mesuré sur la
  // home : fermeture du tiroir à 1,4 s d'INP). Boucle suspendue tant qu'un
  // panneau est ouvert, reprise automatique à la fermeture (sondage 200 ms).
  function overlayOpen() {
    try { if (document.querySelector(':modal')) return true; } catch (e) {}
    return !!document.querySelector('header-drawer details[open]');
  }
  if (window.customElements && customElements.whenDefined) {
    ['bouss-logo-3d', 'bouss-logo-header', 'bouss-barbwire-3d'].forEach(function (tag) {
      customElements.whenDefined(tag).then(function () {
        var C = customElements.get(tag);
        var P = C && C.prototype;
        if (!P || P.__boussOverlayTuned || typeof P.tick !== 'function') return;
        P.__boussOverlayTuned = true;
        var tick = P.tick;
        P.tick = function () {
          if (overlayOpen()) {
            var self = this;
            this.raf = null;
            clearTimeout(this.__boussOverlayTimer);
            this.__boussOverlayTimer = setTimeout(function () {
              if (self.isConnected && typeof self.schedule === 'function') self.schedule();
            }, 200);
            return;
          }
          return tick.apply(this, arguments);
        };
      });
    });
  }

  /* ---- Dock du hero figé pendant qu'un panneau fige la page ------------ */
  // À l'ouverture du tiroir panier (ou de la recherche), le thème fige la
  // page : <body> passe en position:fixed (défilement mémorisé dans top) et le
  // défilement de la fenêtre retombe à 0. Le hero 3D (updateDock) lisait ce 0
  // comme un retour en haut : header masqué, canvas 3D réaffiché avec sa
  // dernière image (logo à une position étrange). Tant que la page est figée,
  // l'état du dock ne bouge pas ; il est recalculé à la fermeture, quand le
  // défilement est restauré.
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('bouss-logo-3d').then(function () {
      var C = customElements.get('bouss-logo-3d');
      var P = C && C.prototype;
      if (!P || P.__boussLockTuned || typeof P.updateDock !== 'function') return;
      P.__boussLockTuned = true;
      var updateDock = P.updateDock;
      P.updateDock = function () {
        if (getComputedStyle(document.body).position === 'fixed') return this.dockP || 0;
        return updateDock.apply(this, arguments);
      };
    });
  }

  /* ---- Galerie conservée au changement de taille ----------------------- */
  // Fiche produit : à chaque choix de variante, Horizon remplace la galerie
  // ENTIÈRE par celle de la page re-demandée au serveur (media-gallery.js,
  // replaceWith) : photos ré-insérées et re-décodées (placeholder BOUSS un
  // instant), carrousel mobile ramené à la 1re photo, rail de vignettes
  // reconstruit. Avant ce remplacement (écoute en capture), si la nouvelle
  // galerie montre les mêmes médias, dans le même ordre, avec la même photo
  // de départ (cas des tailles), on la retire de la réponse : la galerie en
  // place reste telle quelle. Médias différents (variante avec ses propres
  // photos) : remplacement d'Horizon inchangé.
  function galleryKey(gallery) {
    var ids = [];
    var nodes = gallery.querySelectorAll('[data-media-id]');
    for (var i = 0; i < nodes.length; i++) ids.push(nodes[i].getAttribute('data-media-id'));
    var show = gallery.querySelector('slideshow-component');
    return ids.length ? ids.join(',') + '|' + (show ? show.getAttribute('initial-slide') : '') : '';
  }
  document.addEventListener('variant:update', function (e) {
    var html = e.detail && e.detail.data && e.detail.data.html;
    var scope = e.target && e.target.closest && e.target.closest('.shopify-section, dialog');
    if (!html || !html.querySelector || !scope) return;
    var current = scope.querySelector('media-gallery');
    var next = html.querySelector('media-gallery');
    if (!current || !next) return;
    var key = galleryKey(next);
    if (key && key === galleryKey(current)) next.remove();
  }, true);
})();
